import { createAsyncThunk, createSelector, createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit';
import { ApiState } from 'models';
import { getHealthSummaryConfig, HealthSummaryConfigResponse } from 'services';

export type State = ApiState<HealthSummaryConfigResponse, SerializedError>;

// https://redux-toolkit.js.org/api/createAsyncThunk
export const fetchHealthSummryConfig = createAsyncThunk(
  'get/healthSummaryConfig',
  async () => await getHealthSummaryConfig()
);

export const initialState = {
  isLoading: true,
  hasLoaded: false,
  data: {},
  error: null,
} as State;

//https://redux-toolkit.js.org/api/createSlice
const healthSummaryConfigSlice = createSlice({
  name: 'healthSummaryConfig',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchHealthSummryConfig.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(fetchHealthSummryConfig.fulfilled, (state, action: PayloadAction<HealthSummaryConfigResponse>) => {
      state.isLoading = false;
      state.data = action.payload;
      state.hasLoaded = true;
    });

    builder.addCase(fetchHealthSummryConfig.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});

export const stateSelector_ = (state: { healthSummaryConfig: State }): State => state.healthSummaryConfig;

export const healthSummaryConfig_ = createSelector(stateSelector_, (state) => state.data);

export default healthSummaryConfigSlice.reducer;
